export default {
  // service.create
  'service.create.save_service_status_check_form.generate_status_check_validation_schema.status_check_name.requirement.message':
    'Please enter the Health Check name',
  'service.create.save_service_status_check_form.generate_status_check_validation_schema.status_check_name.too_long.message':
    'Health Check name is too long',
  'service.create.save_service_status_check_form.generate_status_check_validation_schema.status_check_name.already_exists.message':
    'Health Check name already exists',
  'service.create.service_status_check_table.description.paragraph1.fragment1':
    'Each of your services will need a',
  'service.create.service_status_check_table.description.paragraph1.fragment2':
    "to evaluate whether your Reliability Tests have passed or failed. Gremlin will work with your existing observability and monitoring tools to automatically halt tests that are causing your Service to fail. If you don't have your monitors set up yet, we recommend setting up monitors that look at: latency, traffic, error rate, and resource saturation.",
  'service.create.service_status_check_table.description.paragraph1.fragment3':
    '. Learn how to add',
  'service.create.service_status_check_table.description.paragraph1.fragment4':
    'to your Service.',
  'service.create.service_status_check_table.description.paragraph2':
    'Once connected, your Health Check monitor will help Gremlin determine how well your Services are weathering Reliability Tests. When Gremlin sees your monitor alerting, Reliability Tests will be automatically halted for this Service.',
  'service.create.service_status_check_table.description.paragraph1.link1.label':
    'Health Check',
  'service.create.service_status_check_table.description.paragraph1.link2.label':
    'Team Settings',
  'service.create.service_status_check_table.table.header.column1':
    'Health Check Name',
  'service.create.service_status_check_table.table.header.column2': 'Actions',
  'service.create.form.service_tag_targeting_selection.no_service_tags.title':
    'No Network Tags',
  'service.create.form.service_tag_targeting_selection.no_service_tags.paragraph.line1':
    'Gremlin needs',
  'service.create.form.service_tag_targeting_selection.no_service_tags.paragraph.line2':
    'to correctly define your Service targets',
  'service.create.form.service_tag_targeting_selection.no_service_tags.paragraph.link':
    'tags',
  'service.create.form.service_type_collection.message':
    'Gremlin is not seeing any running processes where agents have been installed yet. If you just recently installed a new agent, note that it may take up to an hour for it to become available. If it has been more than an hour, make sure you have running processes where you installed your Gremlin agents.',
  'service.create.service_type.k8s_shared_eligible':
    'We’ve seen some namespaces that other teams own that could help you get started without enabling process collection.',

  'services.create.k8s_access_request.btn_cancel': 'Cancel',
  'services.create.k8s_access_request.btn_submit': 'Request Access',
  'services.create.k8s_access_request.description1':
    'Gremlin sees some namespaces that other teams within your company own that could help you get started without enabling process collection. Do you want to request access to any of the namespaces in the below clusters?',
  'services.create.k8s_access_request.description2':
    'Once access is granted, you will be able to proceed with service creation.',
  'services.create.k8s_access_request.cluster_selection.label':
    'Select clusters',
  'services.create.k8s_access_request.cluster_selection.placeholder':
    'Cluster name',

  'services.create.k8s_access_request.label': 'Shareable Namespaces',
  'services.create.k8s_access_request.empty': 'No shareable namespaces to show',
  'services.create.k8s_access_request.loading_error':
    'An error occurred while loading data',
  'services.create.k8s_access_request.list.search': 'Search namespaces',
  'services.create.k8s_access_request.list.headers.cluster_name':
    'Cluster Name',
  'services.create.k8s_access_request.list.headers.namespace':
    'Shared Namespace',
  'services.create.k8s_access_request.list.headers.request_status':
    'Request Status',
  'services.create.k8s_access_request.list.headers.owner': 'Owner',
  'services.create.k8s_access_request.submit.success_message':
    'Request successfully sent. Check in with your team or company manager and return to the service creation flow once access is granted.',

  'service.create.k8s_targeting_selection.shared_namespace_indicator':
    'This object is shared by Team, "{{teamName}}" due to being in a shared namespace. Running a test on a service created with this object may impact that Team’s services as well.',

  // service.details
  'service.details.run_all.dialog.title': 'Run All Tests',
  'service.details.run_all.dialog.button_text': 'Run All Tests',
  'service.details.run_all.dialog.content1':
    "Running all tests may impact your service. You can stop the test suite while it's in progress if needed. This service has {{numberOfSpofDependencies}} Single Point of Failure ",
  'service.details.run_all.dialog.content2': 'Single Point of Failure',
  'service.details.run_all.dialog.content3': 'dependency',
  'service.details.run_all.dialog.content4':
    'Single Point of Failure dependencies will be excluded during a Run All test. You may run a single test on them on the Dependencies page.',
  'service.details.run_all.dialog.content_no_spofs':
    "Your Service may be impacted. You can stop the test suite while it's in progress if needed.",

  'service.details.incomplete_service_guide.completed_section.status_check_added.title':
    'Health Check added',
  'service.details.incomplete_service_guide.getting_started.add_status_check.title':
    'Add a Health Check',
  'service.details.incomplete_service_guide.getting_started.add_status_check.paragraph':
    "Each of your services will need a Health Check to evaluate whether your Reliability Tests have passed or failed. Gremlin will work with your existing observability and monitoring tools to automatically halt tests that are causing your Service to fail. If you don't have your monitors set up yet, we recommend setting up monitors that look at: latency, traffic, error rate, and resource saturation.",
  'service.incomplete.warning': 'To run Reliability Tests, add a Health Check',
  'service.details.incomplete_service_guide.getting_started.run_a_test.paragraph':
    'Pick a test below to run on your Service. Your Health Check will tell Gremlin whether a reliability test has passed or failed. It will also tell Gremlin when to halt the test, if necessary.',
  'service.details.risk-widget.title': 'Detected Risks',
  'service.details.dependencies-widget.title': 'Dependencies',

  // service.details.dependency_failures_table
  'service.details.dependency_failures_table.policy_evaluation_run_details_never_tested':
    'Never tested',
  'service.details.dependency_failures_table.name.header': 'Dependency Name',
  'service.details.dependency_failures_table.results.header': 'Results',
  'service.details.dependency_failures_table.name.tooltip.title1':
    'This dependency was marked as a',
  'service.details.dependency_failures_table.name.tooltip.title2':
    'Single Point of Failure dependency',
  'service.details.dependency_failures_table.name.tooltip.title3':
    'This setting is configurable on the',
  'service.details.dependency_failures_table.name.tooltip.title4':
    'dependencies page',

  // service.details.dependency_list
  'service.details.dependency_list.feature_name_plural': 'Dependencies',
  'service.details.dependency_list.page_title': 'Dependencies: {{serviceName}}',
  'service.details.dependency_list.header': 'Dependencies for {{serviceName}}',
  'service.details.dependency_list.dependency_name.tooltip.title1':
    'This dependency was marked as a',
  'service.details.dependency_list.dependency_name.tooltip.title2':
    'Single Point of Failure dependency',
  'service.details.dependency_list.dependency_name.tooltip.title3':
    'This setting is configurable.',
  'service.details.dependency_list.test_status.never_run.tooltip':
    'Test has yet to be run',
  'service.details.dependency_list.test_status.running.button_label': 'View',
  'service.details.dependency_list.run_test.modal_title':
    'Run {{testName}} on dependency {{dependencyName}}',
  'service.details.dependency_list.test_history_link.aria_label':
    'View Last Run',
  'service.details.dependency_list.run_button.tooltip.title1':
    'This dependency was marked as a',
  'service.details.dependency_list.run_button.tooltip.title2':
    'Single Point of Failure dependency',
  'service.details.dependency_list.run_button.tooltip.title3':
    'Running a test on this dependency may impact your service in an undesirable way.',
  'service.details.dependency_list_page.service_error':
    'There was a problem loading this Service, or it does not exist.',
  'service.details.dependency_list_page.test_already_running':
    'A reliability test is already running',
  'service.details.dependency_list.empty': 'No Dependencies for this Service',
  'service.details.dependency_list.dependency_grid.empty':
    'No Tests for this Dependency',
  'service.details.dependency_list.dependency_grid.headers.name': 'Test Name',
  'service.details.dependency_list.dependency_grid.headers.description':
    'Description',
  'service.details.dependency_list.dependency_grid.headers.run': 'Run',
  'service.details.dependency_list.dependency_grid.headers.result': 'Result',
  'service.details.dependency_list.dependency_grid.result.running': 'Running',
  'service.details.dependency_list.add_dependency_button.label':
    'Add Dependency',
  'service.details.dependency_list.delete_dependency.error':
    'There was an issue deleting your dependency. Please try again later.',
  'service.details.dependency_list.delete_dialog.title': 'Delete Dependency?',
  'service.details.dependency_list.delete_dialog.content':
    '{{dependencyName}} will be deleted',

  // service.details.dependency_form
  'service.details.dependency_form.port.label_all': 'All',
  'service.details.dependency_form.port.label_port_number': 'Port Number',
  'service.details.dependency_form.edit_success.message': 'Dependency updated',
  'service.details.dependency_form.add_success.message': 'Dependency saved',
  'service.details.dependency_form.edit_fail.message':
    'Failed to update dependency',
  'service.details.dependency_form.add_fail.message':
    'Failed to add dependency',
  'service.details.dependency_form.name': 'Dependency Name',
  'service.details.dependency_form.description':
    'Enter a Hostname, IP address, CIDR subnet or cloud service or Port Number. One of these fields must be filled in.',
  'service.details.dependency_form.address.helper_text':
    'Hostname, IP address, CIDR subnet or cloud service',
  'service.details.dependency_form.port.helper_text':
    'As a single port (8080) or as a CSV string with a range (8080, 8082-8085). Leaving blank will mean “all”.',
  'service.details.dependency_form.spof.label':
    'Mark this Dependency as a Single Point of Failure',
  'service.details.dependency_form.spof.tooltip1': 'Single Point of Failure',
  'service.details.dependency_form.spof.tooltip2':
    'dependencies will be excluded from an autoscheduled and Run All test.',
  'service.details.dependency_form.add_button.label': 'Save Dependency',

  // service.incomplete
  'service.incomplete.warning.scheduling':
    'To schedule Reliability Tests, add a Health Check',

  // service.details.service_reliability_tests
  'service.details.service_reliability_tests.test_name.header': 'Test Name',
  'service.details.service_reliability_tests.test_name.description':
    'Description',
  'service.details.service_reliability_tests.test_name.run': 'Run',
  'service.details.service_reliability_tests.test_name.result': 'Result',
  'service.details.service_reliability_tests.view_progress_button.text':
    'View Progress',

  // service.reliability_test
  'service.reliability_test.in_progress':
    'A reliability test is in progress. Wait for it to finish before starting another reliability test.',
  'service.reliability_test.run_test.modal_title': 'Run {{name}} Test?',
  'service.reliability_test.run_test.in_production.modal_title':
    'Run {{name}} Test in Production?',
  'service.reliability_test.run_test.modal_content':
    "Your Service may be impacted. You can stop the test while it's in progress if needed.",
  'service.reliability_test.run_test.modal_content_shared_namespace':
    'This Service has an object shared by Team, "{{teamName}}" due to being in a shared namespace. Running a test on this service may impact that Team\'s services too. You can stop the test while it\'s in progress if needed.',

  // service.reliability_test_history
  'service.reliability_test_history.page_title':
    'Reliability Test History : {{serviceName}}',
  'service.reliability_test_history.page_title_fallback':
    'Reliability Test History',

  'service.reliability_test_history.service_loading.error':
    'There was an error loading this Service. Please try again.',

  'service.reliability_test_history.header.expired':
    'The most recent {{reliabilityTestTitle}} has expired. Run it again to get an updated score.',

  'service.reliability_test_history.run_list.empty':
    'No previous runs for this reliability test',
  'service.reliability_test_history.run_list.source.manual': 'Manual',
  'service.reliability_test_history.run_list.source.scheduled': 'Scheduled',
  'service.reliability_test_history.run_list.table.title': 'Test Run History',
  'service.reliability_test_history.run_list.table.header.date': 'Date',
  'service.reliability_test_history.run_list.table.header.result': 'Result',
  'service.reliability_test_history.run_list.table.header.kind': 'Kind',

  // service.status
  'service.status.service_status_page.details.loading_error.message':
    'Details could not be loaded.',
  'service.status.service_status_page.test_progression.title':
    'Test Progression',
  'service.status.service_status_page.status_checks_info.paragraph':
    'Your Health Checks will continuously monitor your service and halt the test if unhealthy states are reported.',
  'service.status.service_status_page.service_error_retry.alert':
    'There was a problem loading this Service, or it does not exist.',
  'service.status.service_status_page.selected_run_error.alert':
    'There was a problem loading this test run, or it does not exist.',
  'service.status.service_status_page.load_generator.connection.warning.message.part1':
    'We encountered an error connecting to your load generator,',
  'service.status.service_status_page.load_generator.connection.warning.message.part2':
    ', during this run. Please check on the configuration in',
  'service.status.service_status_page.load_generator.warning.message.part1':
    'We encountered an error with your load generator,',
  'service.status.service_status_page.load_generator.warning.message.part2':
    ', during this run. Please check that it has stopped running.',
  'service.status_header.reliability_test.results.expired':
    'This test expired on {{expiryDate}}. Run this test again to refresh the result.',
  'service.status_header.reliability_test.results.failed':
    'Your Health Checks observed unhealthy status codes while Gremlin was testing your system.',
  'service.status_header.reliability_test.results.halted':
    'There was a problem while Gremlin was testing. We recommend trying to run this test again.',
  'service.status_header.reliability_test.results.passed':
    'Your Health Checks observed healthy criteria while Gremlin was testing your system. This test result will expire on {{expiryDate}}',
  'service.status_header.reliability_test.results.user_halted':
    'A user halted this test while it was in progress. Run this test again, without halting, to get results.',

  // service.settings
  'service.settings.status_checks.edit.button.label': 'Edit',
  'service.settings.status_checks.remove.button.label': 'Remove',
  'service.settings.status_checks.remove.modal.title.text':
    'Remove Health Check?',
  'service.settings.status_checks.remove.modal.message.text':
    '{{statusCheckName}} will be removed from this Service',
  'service.settings.status_checks.remove.modal.cancel.button.label': 'Cancel',
  'service.settings.status_checks.add.button.label': 'Add',
  'service.settings.status_checks.add_status_check.success.toast.message':
    'Health Check successfully added to Service',
  'service.settings.status_checks.remove_status_check.success.toast.message':
    'Health Check successfully removed from Service',
  'services.settings.service_autoscheduling.description':
    'Gremlin can automatically schedule recurring Reliability Tests for this service when given a testing window. We will run this Service’s Reliability Tests during your specified window. This is optional.',
  'services.settings.service_autoscheduling.enabled_text1':
    'Autoschedule eligible',
  'services.settings.service_autoscheduling.enabled_text2':
    'Reliability Tests in this Service',
  'services.settings.service_autoscheduling.enabled_tooltip1':
    'Any dependencies marked as a',
  'services.settings.service_autoscheduling.enabled_tooltip2':
    'Single Point of Failure dependency',
  'services.settings.service_autoscheduling.enabled_tooltip3':
    'will be excluded from an autoscheduled test.',
  'services.settings.service_autoscheduling.text.window.header': 'Test Window',
  'services.settings.service_autoscheduling.text.window.description':
    'Select one day per week for your eligible Reliability Tests to run. Gremlin will run as many of the eligible Reliability Tests that it can during the specified window. At a minimum, we will need a two hour window.',
  'services.settings.service_details.no_service_id.error.message':
    'Service Details could not be loaded.',
  'services.settings.service_details.no_service_id.error.button.label':
    'Try Again',

  // common
  'service.common.feature_name_plural': 'Services',
  'service.common.owner_icon.with_name_email_and_team_name':
    'Owned by {{firstName}} {{lastName}} ({{email}}) in {{teamName}}',
  'service.common.owner_icon.with_name_and_email':
    'Owned by {{firstName}} {{lastName}} ({{email}})',
  'service.common.owner_icon.with_name_and_team_name':
    'Owned by {{firstName}} {{lastName}} in {{teamName}}',
  'service.common.owner_icon.with_name': 'Owned by {{firstName}} {{lastName}}',
  'service.common.catalog_list.scheduled_test_window.icon.passed_once.tooltip':
    'This service is queued to run Reliability Tests that have passed at least once during these times:',
  'service.common.catalog_list.scheduled_test_window.icon.run_once.tooltip':
    'This service is queued to run Reliability Tests that have been run at least once during these times:',
  'service.common.catalog_list.scheduled_test_window.icon.always.tooltip':
    'This service is queued to run all Reliability Tests during these times:',

  'service_common.detected_risks.pending.tooltip':
    'Risk evaluation is pending for this service',
  'service_common.detected_risks.unavailable': 'n/a',
  'service_common.detected_risks.unavailable.tooltip':
    'No risks could be evaluated for this Service',
  'service_common.detected_risks.no_deployment.tooltip':
    'No risks evaluated because this service is not deployed',
  'service_common.detected_risks.not_included.tooltip':
    'No risks evaluated because all risks were ignored in the Test Suite',

  'service_common.k8s_access_request.sent.success': 'Request successfully sent',
  'service_common.k8s_access_request.sent.fail':
    'There was an issue requesting access. Please try again later.',

  'service_common.limit_reached_overlay.title':
    "You've reached your service limit.",
  'service_common.limit_reached_overlay.trial.title':
    "You've reached your limit of free services.",
  'service_common.limit_reached_overlay.content1':
    'To add a new service to Gremlin, please',
  'service_common.limit_reached_overlay.content2.link_text': 'contact sales',
  'service_common.limit_reached_overlay.content3': 'to upgrade your account.'
}
